// extracted by mini-css-extract-plugin
export default {"container":"WorldMapPage_container__1qqNi"};